<h5>Last Presence Event</h5>
<pre *ngIf="presence$ | async as presence; else none"
  >{{ presence | json }}
</pre>
<ng-template #none> None </ng-template>
